module.exports = __webpack_public_path__ + "img/pc-home-bg.efed3de8.png";